module.exports = __webpack_public_path__ + "static/media/our-works.e6af6680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Partner/imgs/our-works.jpg
// module id = 1520
// module chunks = 0